import {useAuth0} from "@auth0/auth0-react";

export const useAuthUtil = () => {

  const {loginWithRedirect, logout} = useAuth0();
  
  const auth0Login = (returnTo?: string) => {
    return loginWithRedirect({
      appState: {
        returnTo: returnTo ?? (window.location.pathname + window.location.search)
      }
    });
  }

  const auth0Logout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }
  
  return {auth0Login, auth0Logout}
}